export default () => {

    const linkBlocks = document.querySelectorAll('.link-block');
    
    if(!linkBlocks) {
        return;
    }

    const imageActivator = (e) => {
       
        if(!e.target.classList.contains('link-block-list__link')) {
            return;
        }

        const itemActive = e.target.closest('.link-block-list__item'); 
        const activeName = itemActive.dataset.active;

        if(!activeName) {
            return;
        }
        
        const wrapper = itemActive.closest('.link-block');
        const itemToActive = wrapper.querySelector(`.link-column-images__image[data-active="${activeName}"]`)
       
        if(!itemToActive) {
            return;
        }

        wrapper.querySelector('.link-column-images__image.active').classList.remove('active');
        itemToActive.classList.add('active');
    };

    const imageToDefault = (e) => {
        const wrapper = e.target.closest('.link-block');

        const itemToActive = wrapper.querySelector('.link-column-images__image[data-active="default"]')

        wrapper.querySelector('.link-column-images__image.active').classList.remove('active');
        itemToActive.classList.add('active');
    }

    linkBlocks.forEach(linkBlock => {
        linkBlock.addEventListener('mouseover', imageActivator);
        linkBlock.addEventListener('touchstart', imageActivator);

        linkBlock.addEventListener('mouseout', imageToDefault);
        linkBlock.addEventListener('touchend', imageToDefault);
    });
};
